export default class subscriberSelectCreate {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                loadedSubscribers: '=',
                target: '@'
            },
            controller: ['$scope', '$timeout', '$element', '$filter', 'SweetAlert', 'Translate', 'Subscriber', 'Event', ($scope, $timeout, $element, $filter, SweetAlert, Translate, Subscriber) => {
                const target = $scope.target || '_self';
                $timeout(() => {
                    let subscriberSelect = $($element).selectize({
                        valueField: 'id',
                        labelField: 'email',
                        searchField: 'email',
                        plugins: ['remove_button'],
                        render: {
                            item: function(item, escape) {
                                return  `<div>
                                            <a style="color:inherit;" href="#/subscriber/${item.id}" target="${target}">
                                                ${escape(item.email)}
                                            </a>
                                        </div>`;
                            }
                        },
                        load: (query, callback) => {
                            if (query != '') {
                                Subscriber.search(query, null, null).then((result) => {
                                    callback(result.data);
                                });
                            }
                        },
                        create: (input, callback) => {
                            Subscriber.store({ email: input }).then((subscriber) => {
                                $timeout(() => {
                                    subscriberSelect[0].selectize.addOption({ id: subscriber.data.id, email: subscriber.data.email })
                                    subscriberSelect[0].selectize.addItem(subscriber.data.id)
                                    subscriberSelect[0].selectize.unlock();
                                    subscriberSelect[0].selectize.blur();
                                });
                            }, (error) => {
                                if (error.status == 409) {
                                    SweetAlert.swal(
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:ERROR'),
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:DUPLICATE'),
                                        "error"
                                    );
                                } else {
                                    SweetAlert.swal(
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:ERROR_INPUT'),
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:ERROR_INPUT_BODY'),
                                        "error"
                                    );
                                }

                                subscriberSelect[0].selectize.unlock();
                            });
                        }
                    });

                    var unregisterLoadedSubscribers = $scope.$watch('loadedSubscribers', (newVal) => {
                        if (newVal !== false) {
                            angular.forEach(newVal, (subscriber) => {
                                $timeout(() => {
                                    subscriberSelect[0].selectize.addOption({ id: subscriber.id, email: subscriber.email });
                                    subscriberSelect[0].selectize.addItem(subscriber.id)
                                });
                            });

                            unregisterLoadedSubscribers()
                        }
                    })
                })
            }]
        }
    }
};
